export const NotificationRedirectType = {
  NewPrivateMessage: 'newPrivateMessage',
  CommunityMention: 'communityMention',
  LiveStream: 'liveStream',
  ExpiredSubscription: 'expiredSubscription',
  RenewSubscription: 'renewSubscription',
};
